"use client";

import Link from "next/link";
import Image from "next/image";
import { usePathname } from "next/navigation";

import {
  NavigationMenu,
  NavigationMenuContent,
  NavigationMenuItem,
  NavigationMenuList,
  NavigationMenuTrigger,
} from "@/shadcn/ui/navigation-menu";

import en from "@/public/global/en.svg";
import de from "@/public/global/de.svg";
import br from "@/public/global/brazil.svg";

export default function LanguageSwitcher({
  lang,
}: {
  lang: "en" | "de" | "br";
}) {
  //
  const pathname = usePathname();

  return (
    <NavigationMenu className="min-w-fit pe-2 z-[999] !rounded-[1rem] ">
      <NavigationMenuList>
        <NavigationMenuItem className="">
          <NavigationMenuTrigger className="h-full flex justify-center items-center gap-0 !bg-transparent">
            {pathname.slice(-3) === "/de" ? (
              <Image
                src={de}
                alt="German flag"
                className="min-w-[3rem] w-[3rem]"
              />
            ) : pathname.slice(-3) === "/br" ? (
              <Image
                src={br}
                alt="Brazil flag"
                className="min-w-[3rem] w-[3rem]"
              />
            ) : (
              <Image
                src={en}
                alt="English flag"
                className="min-w-[3rem] w-[3rem]"
              />
            )}
          </NavigationMenuTrigger>
          <NavigationMenuContent className="!bg-none !border-none  bg-white !rounded-[1rem] z-[999]">
            <ul className="flex flex-col w-full h-full min-w-[20rem] min-h-[12rem] pl-[.35rem] pr-[.75rem] pb-[.85rem] pt-[.35rem] space-y-[.75rem]">
              <li className="w-full h-full">
                <Link
                  href={
                    pathname === "/de" || pathname === "/br"
                      ? "/"
                      : lang === "de" || lang === "br"
                        ? pathname.substring(0, pathname.length - 3)
                        : pathname
                  }
                  className={`${pathname.slice(-3) !== "/de" && pathname.slice(-3) !== "/br" ? "font-[500] bg-[#E5EDEA]" : "font-[400] hover:bg-[#E5EDEA]"}  flex items-center gap-3 p-[1.25rem] w-full h-full sans text-[#343434] text-[2.25rem] relative rounded-[.75rem]`}
                >
                  <Image
                    src={en}
                    alt="English flag"
                    className="min-w-[3rem] w-[3rem]"
                  />
                  English
                </Link>
              </li>
              <li className="w-full h-full">
                <Link
                  href={
                    pathname === "/" || pathname === "/br"
                      ? "/de"
                      : pathname.slice(-3) === "/de"
                        ? pathname
                        : pathname.slice(-3) === "/br"
                          ? pathname.substring(0, pathname.length - 3) + "/de"
                          : pathname + "/de"
                  }
                  className={`${pathname.slice(-3) === "/de" ? "font-[500] bg-[#F7F5F1]" : "font-[400]"}  flex items-center gap-3 p-[1.25rem] w-full h-full sans text-[#343434] text-[2.25rem] relative rounded-[.75rem]`}
                >
                  <Image
                    src={de}
                    alt="German flag"
                    className="min-w-[3rem] w-[3rem]"
                  />
                  Deutsch
                </Link>
              </li>
              <li className="w-full h-full">
                <Link
                  href={
                    pathname === "/" || pathname === "/de"
                      ? "/br"
                      : pathname.slice(-3) === "/br"
                        ? pathname
                        : pathname.slice(-3) === "/de"
                          ? pathname.substring(0, pathname.length - 3) + "/br"
                          : pathname + "/br"
                  }
                  className={`${pathname.slice(-3) === "/br" ? "font-[500] bg-[#F7F5F1]" : "font-[400]"}  flex items-center gap-3 p-[1.25rem] w-full h-full sans text-[#343434] text-[2.25rem] relative rounded-[.75rem]`}
                >
                  <Image
                    src={br}
                    alt="Brazil flag"
                    className="min-w-[3rem] w-[3rem]"
                  />
                  Português
                </Link>
              </li>
            </ul>
          </NavigationMenuContent>
        </NavigationMenuItem>
      </NavigationMenuList>
    </NavigationMenu>
  );
}
